import { useState } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { requestMagicLink } from "@/api/auth";
import { Button } from "@/components/ui/button";
import { AuthCard } from "@/components/common/AuthCard";

export const Route = createFileRoute("/login_/sent")({
  validateSearch: (s: Record<string, unknown>): { email: string; dev_link?: string; redirect?: string } => ({
    email: typeof s.email === "string" ? s.email : "",
    ...(typeof s.dev_link === "string" ? { dev_link: s.dev_link } : {}),
    ...(typeof s.redirect === "string" ? { redirect: s.redirect } : {}),
  }),
  component: SentPage,
});

function SentPage() {
  const { email, dev_link, redirect } = Route.useSearch();
  const [resent, setResent] = useState(false);
  const [devLink, setDevLink] = useState(dev_link);

  const resend = async () => {
    const r = await requestMagicLink(email);
    setDevLink(r.dev_link);
    setResent(true);
  };

  const href = devLink ? appendRedirect(devLink, redirect) : null;

  return (
    <AuthCard title="Check your email" subtitle={`We sent a sign-in link to ${email}. It expires in 15 minutes.`}>
      {href && (
        <div className="rounded-md border border-dashed border-ai/50 bg-accent/40 p-3 text-sm">
          <div className="mb-1 text-xs font-medium uppercase tracking-wide text-muted-foreground">Local dev: email delivery is off</div>
          <a className="break-all text-primary underline" href={href}>
            Open the sign-in link
          </a>
        </div>
      )}
      <div className="mt-4 flex items-center justify-between text-sm text-muted-foreground">
        <Link to="/login" search={{ redirect }} className="underline">
          Use a different email
        </Link>
        <Button variant="ghost" size="sm" onClick={resend} disabled={resent}>
          {resent ? "Sent again" : "Resend"}
        </Button>
      </div>
    </AuthCard>
  );
}

function appendRedirect(link: string, redirect?: string) {
  if (!redirect) return link;
  const u = new URL(link, window.location.origin);
  u.searchParams.set("redirect", redirect);
  return u.pathname + u.search;
}
